<template>
  <aside class="MobileView" v-if="content.kind === 'multichoice'" :class="[status, { isFullHeight }]">
    <MobileIndicator
      v-bind="{ showPopup }"
      :notificationActivated="triggered"
      :text="content.multichoicePopup.mobileNotificationMessage"
      class="mobileIndicator"
    />
    <div class="popup">
      <MultichoicePopup
        :content="content.multichoicePopup"
        v-bind="{ hidePopup, ctaClicked, setIsFullHeight }"
      />
    </div>
  </aside>
</template>

<script>
import { pushAnalyticsEvent } from '~/lib/analyticsEvents.js'

import MobileIndicator from './MobileIndicator.vue'
import MultichoicePopup from './MultichoicePopup/index.vue'

function pushPopupAnalyticsEvent(content, action) {
  pushAnalyticsEvent({
    scope: 'multichoicePromoPopup',
    action,
    content: content.multichoicePopup,
  })
}

export default {
  components: {
    MobileIndicator,
    MultichoicePopup,
  },
  props: {
    content: Object,
    triggered: Boolean,
  },
  data() {
    return {
      status: 'ready',
      isFullHeight: false,
    }
  },
  methods: {
    showPopup() {
      this.status = 'showing'
      pushPopupAnalyticsEvent(this.content, 'revealedOnMobile')
    },
    hidePopup(reason) {
      this.status = 'dismissed'
      if (reason === 'closed') {
        pushPopupAnalyticsEvent(this.content, 'dismissed')
      }
    },
    ctaClicked() {
      pushPopupAnalyticsEvent(this.content, 'ctaClicked')
    },
    setIsFullHeight(value) {
      this.isFullHeight = value;
    },
  },
}
</script>

<style scoped>

.MobileView {
  position: fixed;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 30;
  display: grid;
  align-items: end;
  pointer-events: none;
  transition: background-color 0.25s;
}

.MobileView.isFullHeight {
  top: 0;
}

.MobileView:not(.isFullHeight) {
  bottom: 0;
}

.MobileView > * {
  grid-row: 1;
  grid-column: 1;
  pointer-events: all;
}

.mobileIndicator {
  max-width: 92%;
  margin-left: auto;
  margin-right: 4%;
}

.popup {
  position: relative;
  top: 100vh;
  transition: top 0.25s;
}

.MobileView.showing {
  background-color: rgba(0, 0, 0, 0.2);
}

.MobileView.showing .popup {
  top: 0;
}
</style>
